export enum QueryTicketResolutionType {
  Resolve = 1,
  ResolveAndReplaceAttachment = 2,
  ResolveAndCreateNewDocument = 3,
  ResolveUsingExistingDocument = 4,
  // ResolveAndAddTheSelectedDocumentToThePlaceholder = 4,
}
